export class Config {
  static BASE_URL = "https://asna-api.codebnb.me/api/v0/";
  //static BASE_URL = "http://asna-api.codebnb.me/api/v0/";
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/config.ts